import { Link, withCitrusTheme } from '@gousto-internal/citrus-react'

export const LinkWithoutUnderline = withCitrusTheme(Link, () => ({
  textDecoration: 'none',
  boxShadow: 'none',
}))
